// Find your formula: answers are links to their result (#match-<handle>), so the
// quiz works without JavaScript. This only marks the chosen answer and moves focus.
if (!customElements.get('protocol-quiz')) {
  class ProtocolQuiz extends HTMLElement {
    connectedCallback() {
      this.onHash = () => this.sync();
      window.addEventListener('hashchange', this.onHash);
      this.addEventListener('click', (event) => {
        const restart = event.target.closest('[data-quiz-restart]');
        if (!restart) return;
        event.preventDefault();
        history.replaceState(null, '', window.location.pathname + window.location.search);
        this.sync();
        this.scrollIntoView({ block: 'start' });
        const first = this.querySelector('[data-quiz-answer]');
        if (first) first.focus();
      });
      this.sync(true);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.onHash);
    }

    sync(initial) {
      const id = window.location.hash.slice(1);
      const result = id && id.indexOf('match-') === 0 ? this.querySelector(`#${CSS.escape(id)}`) : null;
      this.querySelectorAll('[data-quiz-answer]').forEach((answer) => {
        const chosen = result && answer.dataset.quizAnswer === id.slice(6);
        answer.classList.toggle('n-quiz__answer--chosen', Boolean(chosen));
        if (chosen) answer.setAttribute('aria-current', 'true');
        else answer.removeAttribute('aria-current');
      });
      if (result && !initial) result.focus({ preventScroll: true });
    }
  }
  customElements.define('protocol-quiz', ProtocolQuiz);
}
